import { RootState } from '@redux/store';

export const getUserWarranty = (state: RootState) => state.warrantyUser.userWarranty;
export const getIsLoadedUserWarranty = (state: RootState) => state.warrantyUser.isLoadedUserWarranty;
export const getIsErrorUserWarranty = (state: RootState) => state.warrantyUser.isError;
